export enum UserType {
    SuperAdmin = "SuperAdmin",
    Tenant = "Tenant",
    Shipping = "Shipping",
    Forwarder = "Forwarder",
    Customer = "Customer"
}
